import React from 'react';
// Falls ihr Next.js nutzt, importiere Head: import Head from 'next/head';
// Falls ihr React nutzt, nutze react-helmet für SEO Meta-Tags.

const Gespraechsraum = () => {
  return (
    <>
      {/* --- SEO & META TAGS --- */}
      {/* <Head>
        <title>Gesprächsraum | Systemisches Coaching & Konfliktlösung | Frequenz 741</title>
        <meta name="description" content="Der Frequenz 741 Gesprächsraum bietet einen geschützten, wertfreien Ort für ehrliche Gespräche, Paarberatung und neue Perspektiven in Bautzen." />
        <meta name="keywords" content="Gesprächsraum, Systemisches Coaching, Konfliktlösung, Paarberatung, Perspektivenwechsel, Frequenz 741, Bautzen" />
        <link rel="canonical" href="https://frequenz741.de/gespraechsraum" />
      </Head> */}

      <main className="bg-[#FCFDFD] text-gray-800 font-sans leading-relaxed selection:bg-emerald-200 selection:text-emerald-900">
        
        {/* --- HERO SECTION --- */}
        <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-28 overflow-hidden bg-emerald-900/5">
          {/* HINTERGRUNDBILD-PLATZHALTER */}
          {/* Stock-Vektorgrafik: „Continuous line drawing of a woman talking to a man during a therapy session.“ */}
          <div className="absolute inset-0 pointer-events-none opacity-10 flex justify-center items-center z-0">
            <img 
              src="AdobeStock_2038471338.jpeg" 
              alt="Continuous line drawing of a woman talking to a man during a therapy session" 
              className="w-full h-full object-cover max-w-7xl mx-auto"
            />
          </div>

          <div className="max-w-6xl mx-auto px-6 relative z-10 text-center">
            <h1 className="text-5xl md:text-7xl font-light text-gray-900 mb-8 leading-tight tracking-tight">
              Frequenz 741 <br />
              <span className="font-bold text-emerald-800">Gesprächsraum</span>
            </h1>
            <p className="text-2xl md:text-3xl text-gray-700 italic max-w-4xl mx-auto font-light leading-snug">
              Ein geschützter Ort in Bautzen oder an einem Ort Ihrer Wahl (bundesweit) für ehrliche Gespräche, neue Perspektiven und nachhaltige Veränderung.
            </p>
          </div>
        </section>

        {/* --- EINLEITUNG & PHILOSOPHIE --- */}
        <section className="max-w-6xl mx-auto px-6 py-20">
          <div className="text-center max-w-4xl mx-auto mb-14">
            <h2 className="text-2xl md:text-3xl text-gray-900 font-medium leading-snug mb-8">
              Alles, was Sie bewegt, verdient Raum. Manchmal beginnt Veränderung genau dort, wo Sie offen aussprechen können, was Sie wirklich beschäftigt.
            </h2>
            
            {/* NEUER BUTTON */}
            <div className="flex justify-center mb-6">
              <a 
                href="mailto:enrico.pohl@frequenz741.de" 
                className="group inline-flex items-center justify-center bg-emerald-800 text-white hover:bg-emerald-900 font-semibold py-4 px-8 rounded-lg transition-all duration-300 shadow-md hover:shadow-xl text-base md:text-lg w-full sm:w-auto text-center"
              >
                Kostenfreies Kennenlerngespräch vereinbaren <br className="sm:hidden" /> (15-20 Minuten, per Telefon oder Videocall)
              </a>
            </div>
          </div>

          {/* Grid Layout mit Bild links, Text Mitte, Bild rechts */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            
            {/* Bild Links: Woman holds her head / stress */}
            <div className="lg:col-span-3 flex justify-center order-1 lg:order-1">
              <div className="w-full max-w-xs p-4">
                <img 
                  src="AdobeStock_379746185.jpeg" 
                  alt="Confused woman one line drawing - Stress & Überforderung" 
                  className="w-full h-auto mx-auto object-contain max-h-64"
                />
              </div>
            </div>

            {/* Haupttext Mitte */}
            <div className="lg:col-span-6 order-2 lg:order-2 space-y-6 text-gray-700 leading-relaxed text-base md:text-lg">
              <p>
                Im Gesprächsraum von Frequenz 741 geht es – ob als Paar oder allein – nicht um richtig oder falsch. Es geht um das Menschsein mit allem, was dazugehört: Gedanken, die nicht zur Ruhe kommen, Gefühle, die schwer einzuordnen sind, Konflikte, Unsicherheiten und die Sehnsucht nach Klarheit, Verbundenheit und innerem Gleichgewicht. Jeder Mensch bringt seine eigene Geschichte, seine Erfahrungen und seine Perspektive mit. Genau dafür schaffen wir einen geschützten, wertfreien Raum, in dem Sie sich zeigen dürfen, ohne bewertet zu werden. Einen Ort, an dem Sie gehört werden, Ihre Gedanken ordnen, neue Sichtweisen entwickeln und festgefahrene Muster Schritt für Schritt lösen können.
              </p>
              <p>
                Aus unserer tiefen Verbundenheit zur Natur und auf Grundlage des <strong>Systemischen Coachings</strong> begleiten wir Sie mit Offenheit, Empathie und einem klaren Blick auf Ihre individuelle Situation. Wir hören aufmerksam zu, stellen die Fragen, die neue Perspektiven eröffnen, und geben gezielte Impulse, die nachhaltige Veränderungen ermöglichen. So unterstützen wir Sie dabei, Herausforderungen bewusst zu begegnen und wieder in eine echte Verbindung zu kommen – mit sich selbst und, wenn Sie als Paar zu uns kommen, auch miteinander.
              </p>
            </div>

            {/* Bild Rechts: Man in depression / headache */}
            <div className="lg:col-span-3 flex justify-center order-3">
              <div className="w-full max-w-xs p-4">
                <img 
                  src="AdobeStock_1495883815.jpeg" 
                  alt="Man in depression continuous one line drawing" 
                  className="w-full h-auto mx-auto object-contain max-h-64"
                />
              </div>
            </div>

          </div>
        </section>

        {/* --- ZIELGRUPPE (FEATURE CARDS) --- */}
        <section className="bg-emerald-50 py-24">
          <div className="max-w-6xl mx-auto px-6">
            <div className="text-center max-w-3xl mx-auto mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-emerald-900 mb-4">
                Ist der Gesprächsraum das Richtige für Sie?
              </h2>
              <p className="text-lg text-emerald-800">
                Der Gesprächsraum richtet sich an Menschen, die sich bewusst Zeit nehmen möchten, ihre aktuelle Situation zu reflektieren und neue Wege zu entdecken. Vielleicht erkennen Sie sich in einer der folgenden Situationen wieder:
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              
              {/* Card 1 */}
              <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-emerald-100 flex flex-col justify-between">
                <div>
                  <div className="w-full h-40 mb-6 rounded-xl flex items-center justify-center overflow-hidden p-2">
                    <img 
                      src="AdobeStock_2110125887.jpeg" 
                      alt="Klarheit in der Beziehung Line Drawing" 
                      className="h-full object-contain" 
                    />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Klarheit in der Beziehung</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Sie wünschen sich wieder mehr Verständnis, Nähe und eine gemeinsame Ausrichtung. Vielleicht drehen sich Gespräche im Kreis oder Konflikte belasten Ihre Beziehung zunehmend.
                  </p>
                </div>
              </div>

              {/* Card 2 */}
              <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-emerald-100 flex flex-col justify-between">
                <div>
                  <div className="w-full h-40 mb-6 rounded-xl flex items-center justify-center overflow-hidden p-2">
                    <img 
                      src="AdobeStock_1915035614.jpeg" 
                      alt="Wenn Entscheidungen schwerfallen Line Drawing" 
                      className="h-full object-contain" 
                    />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Wenn Entscheidungen schwerfallen</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Sie stehen vor einer wichtigen beruflichen oder privaten Entscheidung und wünschen sich einen neutralen Raum, um Gedanken zu sortieren und Klarheit zu gewinnen.
                  </p>
                </div>
              </div>

              {/* Card 3 */}
              <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-emerald-100 flex flex-col justify-between">
                <div>
                  <div className="w-full h-40 mb-6 rounded-xl flex items-center justify-center overflow-hidden p-2">
                    <img 
                      src="AdobeStock_2002199044.jpeg" 
                      alt="Orientierung in Veränderungsphasen Line Drawing" 
                      className="h-full object-contain" 
                    />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Orientierung in Veränderungsphasen</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Ob beruflicher Wechsel, Trennung, Familienveränderungen oder persönliche Neuorientierung – manche Lebensphasen stellen vieles auf den Prüfstand. Gemeinsam entwickeln wir neue Perspektiven und stärken Ihren Blick nach vorn.
                  </p>
                </div>
              </div>

              {/* Card 4 */}
              <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-emerald-100 flex flex-col justify-between">
                <div>
                  <div className="w-full h-40 mb-6 rounded-xl flex items-center justify-center overflow-hidden p-2">
                    <img 
                      src="AdobeStock_2070419367.jpeg" 
                      alt="Konflikte nachhaltig lösen Line Drawing" 
                      className="h-full object-contain" 
                    />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Konflikte nachhaltig lösen</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Unausgesprochene Spannungen oder wiederkehrende Konflikte kosten Kraft. Gemeinsam schauen wir auf die Hintergründe und entwickeln Wege zu einem wertschätzenden Miteinander.
                  </p>
                </div>
              </div>

              {/* Card 5 */}
              <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-emerald-100 flex flex-col justify-between">
                <div>
                  <div className="w-full h-40 mb-6 rounded-xl flex items-center justify-center overflow-hidden p-2">
                    <img 
                      src="AdobeStock_2094289910.jpeg" 
                      alt="Wenn der Alltag zu laut wird Line Drawing" 
                      className="h-full object-contain" 
                    />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Wenn der Alltag zu laut wird</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Stress, Überforderung oder der ständige Druck, funktionieren zu müssen, lassen oft kaum Raum für die eigenen Gedanken und Gefühle. Im Gesprächsraum dürfen Sie innehalten und sich wieder bewusst wahrnehmen.
                  </p>
                </div>
              </div>

              {/* Card 6 */}
              <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-emerald-100 flex flex-col justify-between">
                <div>
                  <div className="w-full h-40 mb-6 rounded-xl flex items-center justify-center overflow-hidden p-2">
                    <img 
                      src="AdobeStock_2017257889.jpeg" 
                      alt="Jemand der zuhört Line Drawing" 
                      className="h-full object-contain" 
                    />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Jemand, der zuhört</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Manchmal braucht es keine schnellen Lösungen, sondern einen Menschen, der aufmerksam zuhört, die richtigen Fragen stellt und neue Blickwinkel eröffnet. Ein geschützter Raum kann der erste Schritt zu mehr Klarheit und innerer Balance sein.
                  </p>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* --- ABGRENZUNG / TRANSPARENZ --- */}
        <section className="max-w-4xl mx-auto px-6 py-16">
          <div className="border-l-4 border-emerald-400 pl-6 py-4 text-gray-600 bg-emerald-50/40 rounded-r-xl shadow-sm">
            <h4 className="font-bold text-gray-900 mb-2 text-lg">
              Was der Gesprächsraum ist – und was nicht
            </h4>
            <p className="leading-relaxed">
              Der Gesprächsraum ist ein Coaching-Angebot zur persönlichen Reflexion und Weiterentwicklung. Er ersetzt keine psychotherapeutische oder medizinische Behandlung und richtet sich an Menschen, die ihre aktuelle Lebenssituation bewusst gestalten möchten.
            </p>
          </div>
        </section>

        {/* --- CALL TO ACTION --- */}
        <section className="bg-emerald-900 text-white text-center py-24 px-6 relative overflow-hidden">
          <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent"></div>
          
          <div className="max-w-4xl mx-auto relative z-10">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
              Ihr erster Schritt beginnt mit einem Gespräch.
            </h2>
            <p className="text-lg md:text-xl text-emerald-100 font-light mb-8 max-w-2xl mx-auto leading-relaxed">
              Wenn Sie das Gefühl haben, dass jetzt der richtige Zeitpunkt ist, begleiten wir Sie gern.
            </p>

            <p className="text-xl font-semibold mb-3 text-white">
              Vereinbaren Sie jetzt Ihr kostenfreies Kennenlerngespräch (15-20 Minuten)
            </p>
            <p className="text-base text-emerald-100/90 mb-10 max-w-2xl mx-auto">
              Dabei erhalten Sie die Möglichkeit, Ihr Anliegen kurz zu schildern und uns sowie unsere Arbeitsweise kennenzulernen. Gemeinsam schauen wir, ob eine Begleitung für Sie stimmig ist.
            </p>
            
            <div className="flex flex-col sm:flex-row justify-center items-center gap-6">
              <a 
                href="mailto:enrico.pohl@frequenz741.de" 
                className="group inline-flex items-center justify-center bg-white text-emerald-900 hover:bg-emerald-50 font-bold py-5 px-10 rounded-lg transition-all duration-300 shadow-xl text-lg w-full sm:w-auto"
                aria-label="Schreiben Sie uns eine E-Mail an enrico.pohl@frequenz741.de"
              >
                Jetzt Termin mit Enrico Pohl vereinbaren 
                <span className="ml-3 transform group-hover:translate-x-1 transition-transform duration-200">→</span>
              </a>
              
              <a 
                href="tel:+491723570148" 
                className="inline-flex items-center justify-center bg-transparent border-2 border-emerald-100/30 text-white hover:bg-emerald-800 hover:border-emerald-100 font-semibold py-5 px-10 rounded-lg transition-all duration-300 text-lg w-full sm:w-auto"
                aria-label="Rufen Sie uns an unter +49 172 3570148"
              >
                <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                </svg>
                +49 172 3570148
              </a>
            </div>
          </div>
        </section>

      </main>
    </>
  );
};

export default Gespraechsraum;